import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchQuestionnairesApi } from '../../api/questionnaires-api';
import { getQueryString } from '../../utils/filters-util';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  questions: [],
  products: [],
  type: [],
  eventType: [],
  activeColumns: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchQuestionnairesListing = createAsyncThunk(
  'questionnaire/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
    try {
      const paramsObj = {
        'q[s]': 'updated_at desc',
        ...updatedParamsObject,
      };
      const res = await fetchQuestionnairesApi(getQueryString(paramsObj));
      if (res?.status) {
        dispatch(setQuickLinks(res?.user_filters));
      }
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

const QuestionnairesSlice = createSlice({
  name: 'questionnaire',
  initialState,
  reducers: {
    setQuestionnairesLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setQuestionnairesActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
    setQuestionnairesData: (state, action) => {
      state.questions = action?.payload || [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchQuestionnairesListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchQuestionnairesListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.questions = action?.payload?.data || [];
        state.type = action?.payload?.product_questionnaire_types || [];
        state.eventType = action?.payload?.product_questionnaire_event_types || [];
        state.products = action?.payload?.products || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchQuestionnairesListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setQuestionnairesLoading, setQuestionnairesActiveColumn, setQuestionnairesData } =
  QuestionnairesSlice.actions;
export default QuestionnairesSlice.reducer;
